module.exports = __webpack_public_path__ + "img/title_sign.a0edf302.png";